<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      persistent
      dark
      enable-resize-watcher
      fixed
      app
      width="370"
    >
      <v-toolbar flat class="drawer-toolbar" dense>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('menu.title') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list v-if="loggedFinal()">
        <v-list-item
          v-if="$auth.logged()"
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'Home',
            params: {
              namespaceonly: true,
            },
          }"
        >
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('menu.home') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="$auth.hasRole('ROLE_PARTICIPANT')"
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{ name: 'participant/mesrendezvous' }"
        >
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{
            $t('menu.particupantsRendezVous')
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="
            $auth.hasRole('ROLE_CORRESPONDANT') ||
            $auth.hasRole('ROLE_PARTICIPANT')
          "
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: '/mescoordonnees',
            params: {
              namespaceonly: true,
            },
          }"
        >
          <v-list-item-action>
            <em class="fas fa-user"></em>
          </v-list-item-action>
          <v-list-item-title>{{
            $t('menu.participantCoordonnes')
          }}</v-list-item-title>
        </v-list-item>

        <v-list-group
          active-class="activeClass"
          exact-active-class="activeLink"
          prepend-icon="assignment_ind"
          value="true"
          v-if="$auth.hasRole('ROLE_PARTICIPANT') && $auth.dmcAccepte()"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.documents.titre')
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'document/resultatsAnalyses',
              params: {
                namespaceonly: true,
                categorie: 'MEDICO_TECHNIQUE',
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.documents.resultatsAnalyses')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'document/consultations',
              params: {
                namespaceonly: true,
                categorie: 'CONS_MEDICAL',
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.documents.consultations')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'document/courrier',
              params: {
                namespaceonly: true,
                categorie: 'COURRIER',
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.documents.courrier')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'document/consultationGynecologique',
              params: {
                namespaceonly: true,
                categorie: 'CONSULT_GYN',
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.documents.consultationGynecologique')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          active-class="activeClass"
          exact-active-class="activeLink"
          prepend-icon="group"
          value="true"
          v-if="$auth.hasRole('ROLE_CORRESPONDANT')"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.adherents.etablissement')
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'adherentsCorrespondant',
              params: {
                namespaceonly: true,
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.adherents.etablissement')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'bilansCorrespondant',
              params: {
                namespaceonly: true,
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.adherents.bilans')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            active-class="activeClass"
            exact-active-class="activeLink"
            :to="{
              name: 'historiqueBilansCorrespondant',
              params: {
                namespaceonly: true,
              },
            }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t('menu.adherents.historiqueBilans')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-if="$auth.hasRole('ROLE_CORRESPONDANT')"
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'mutation/liste',
            params: { namespaceonly: true },
          }"
        >
          <v-list-item-action>
            <v-icon dark>mdi-swap-horizontal</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('menu.mutation') }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="$auth.hasRole('ROLE_PARTICIPANT') && $auth.dmcAccepte()"
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'fiche/liste',
            params: {
              namespaceonly: true,
            },
          }"
        >
          <v-list-item-action>
            <v-icon>mdi-note-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('menu.fichesConseil') }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            $auth.hasRole('ROLE_CORRESPONDANT') || canShowListeCorrespondant
          "
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'correspondant/liste',
            params: { namespaceonly: true },
          }"
        >
          <v-list-item-action>
            <v-icon dark>mdi-contacts</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('menu.morrespondants') }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'assistance',
            params: { namespaceonly: true },
          }"
        >
          <v-list-item-action>
            <v-icon dark>mdi-forum</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('menu.assistance') }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          active-class="activeClass"
          exact-active-class="activeLink"
          :to="{
            name: 'politiqueProtectionDonnees',
          }"
        >
          <v-list-item-action>
            <v-icon dark>mdi-shield-lock</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{
            $t('menu.politiqueProtectionDonnees')
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar dark app dense color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span v-html="$t(title)"></span>
      </v-toolbar-title>

      <v-spacer />
      <v-toolbar-items>
        <v-fade-transition mode="out-in">
          <date
            v-if="hasDate && $auth.logged()"
            v-model="isoToday"
            class="mr-2"
          />
        </v-fade-transition>

        <v-menu :nudge-right="50" class="auth-menu">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text class="drawer-toolbar">
              <v-icon>account_circle</v-icon>
              <div v-if="$auth.logged()">
                {{ $auth.nomComplet() }}
              </div>
            </v-btn>
          </template>
          <v-list>
            <template v-if="$auth.logged()">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    ><strong>{{
                      $auth.nomComplet()
                    }}</strong></v-list-item-title
                  >
                  <v-list-item-subtitle>{{
                    $auth.userid()
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-list-item @click="logout">
                <v-list-item-title>{{ $t('login.signout') }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item v-if="!$auth.logged()" :to="{ name: 'Login' }">
              <v-list-item-title>{{ $t('login.signin') }}</v-list-item-title>
            </v-list-item>

            <v-divider />
            <v-lang-selector>
              <template v-slot="lang">
                <v-list-item
                  :color="lang.active ? 'info' : ''"
                  :key="lang.id"
                  href="#"
                >
                  <v-list-item-title>{{ lang.label }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-lang-selector>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <v-container fluid class="pa-0">
        <v-scroll-x-transition>
          <bread-crumb />
        </v-scroll-x-transition>
      </v-container>
      <v-container fluid grid-list-sm class="pa-2">
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-main>

    <v-footer fixed app inset>
      <template>
        <v-spacer />
        <span class="px-3">&copy; {{ new Date().getFullYear() }} CIEM</span>
      </template>
      <v-progress-linear
        :active="loading"
        height="4"
        color="accent"
        indeterminate
      />
    </v-footer>
  </v-app>
</template>

<script>
console.log(
  '%c Attention, ne jamais copier une information depuis cette fenêtre ou depuis un autre onglet.',
  'background: red;padding: 10px;',
)
import Mousetrap from 'mousetrap'

import moment from 'moment'
import version from '@/assets/version.json'
import hash from '@/assets/hash.json'

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      hasEvents: false,
      hasDate: false,
      title: 'menu.default',
      version,
      hash,
    }
  },
  computed: {
    loading() {
      return this.$store.getters['loader/spinning']
    },

    isoToday: {
      get() {
        return this.$store.state.today.iso
      },
      set(value) {
        this.$store.commit('today/iso', value)
      },
    },
    planifEnCours() {
      return this.$store.state.confirmauthentification.enCours
    },
    canShowListeCorrespondant() {
      return this.$store.getters['oauth/canShowListeCorrespondant']
    },
  },
  watch: {
    $route(to) {
      this.watchRoute(to)
    },
  },
  beforeMount() {
    if (this.$i18n) {
      moment.locale(this.$i18n.locale.substr(0, 2))
    }
  },
  mounted() {
    this.watchRoute(this.$route)
  },
  created() {
    Mousetrap.bind('shift+m', () => {
      this.toggleDrawer()
    })
  },
  methods: {
    logout() {
      this.$auth.logout()
      this.drawer = false
      this.$store.commit('confirmauthentification/enCours', false)
      this.$store.commit('oauth/token', null)
      this.$store.commit('oauth/user', null)
    },
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    watchRoute(to) {
      let title = 'menu.default'
      if (to.meta.breadcrumb) {
        const rawBread = to.meta.breadcrumb(to)
        if (rawBread.length) {
          title = rawBread[rawBread.length - 1].code
        }
      }
      this.title = title
      this.hasDate = to.meta.globalDate || false
      if (to.params.sidebar) {
        this.drawer = true
      }
    },

    loggedFinal() {
      return this.$store.state.confirmauthentification.enCours
    },
    // requestCanShowListeCorrespondant() {
    //   this.$api('user/canShowListeCorrespondant').get().then(response => {
    //     this.canShowListeCorrespondant = response.body;
    //   });
    // },
  },
}
</script>

<style>
:root {
  --disabled-bg-color: #eee;
}

.theme--dark.v-navigation-drawer {
  background-color: var(--v-primary-base);
}

.activeClass .v-list__tile__title {
  color: inherit;
}

.activeClass .v-list-item__content {
  color: white !important;
}

.activeClass .v-list-item__icon {
  color: white !important;
}

.v-list__tile__action {
  color: var(--v-headerDrawer-base);
}

.activeLink .v-list__tile__title {
  border-bottom: 3px solid #ffffff;
  width: auto !important;
}

.v-list__tile {
  font-weight: bold !important;
  text-transform: uppercase;
}

a.v-list__tile .v-list__tile__content {
  font-size: 12px !important;
  margin-left: 20px;
  font-weight: normal;
}

.v-menu__content .v-list__tile .v-list__tile__content {
  font-size: 12px !important;
  margin-left: 20px;
  font-weight: normal;
}

.drawer-toolbar {
  background-color: var(--v-headerDrawer-base) !important;
}

.primary a {
  color: #ffffff;
}

a {
  color: var(--v-primary-base);
  text-decoration: none;
}

.toasted-container {
  font-family: 'Montserrat', sans-serif;
  line-height: 1.5;
}

footer .v-progress-linear {
  margin: 0px;
  position: absolute;
  bottom: 0;
}

.activeLink .v-list-item__title {
  border-bottom: 3px solid #ffffff;
  width: auto !important;
  flex: none;
}

/* Animations
*/
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.bounce-enter-active {
  animation: bounce-in 0.3s;
}

.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 2px;
}

.v-messages {
  min-height: 13px;
  font-size: 13px;
}

.v-input.v-text-field {
  margin-top: 0px !important;
  padding-top: 0;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.v-text-field .v-text-field__slot,
.v-text-field .v-select__slot {
  padding-top: 0px;
  padding-bottom: 2px;
  color: #000000;
}

.v-label.theme--light {
  top: auto;
  bottom: 2px;
}

.v-label.theme--light.v-label--active {
  top: 6px;
  bottom: -4px;
}

.v-text-field__details {
  margin-top: 2px;
}

.v-counter {
  font-size: 8px;
}

input {
  color: #000000 !important;
  font-weight: bold !important;
}

.v-input--selection-controls__ripple {
  margin: 0px;
  width: 24px;
  height: 24px;
  left: 0;
  top: 0;
}

input {
  padding: 0px !important;
}

.theme--light.v-label {
  color: var(--v-label-base) !important;
}

.v-label--active {
  font-size: 14px;
}

.v-tabs__bar {
  margin-bottom: 3px;
}

a.v-list-item .v-list-item__content {
  font-size: 9px !important;
  margin-left: 20px;
  font-weight: normal;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.35);
  }

  100% {
    transform: scale(1);
  }
}

li.disabled a {
  color: var(--v-secondary-base) !important;
}

a.v-list__tile {
  font-size: 13px;
}

div.v-input {
  font-size: 13px;
}

.v-label {
  font-size: 16px !important;
}

.v-input .material-icons {
  font-size: 18px;
}

div.v-tabs__div {
  font-size: 13px;
}

legend {
  font-size: 13px;
  margin-bottom: 10px;
}

.v-input {
  font-size: 12px;
}

.v-label {
  font-size: 12px;
}

.v-input__slot {
  margin-bottom: 0px;
}

div[class~='md'] {
  padding: 0;
}

a.v-tabs__item {
  padding-top: 0;
  padding-bottom: 3px;
}

.v-tabs__container {
  height: 25px;
  margin-bottom: 9px;
}

.v-system-bar--window {
  font-size: 13px;
}

label.v-label.v-label--active.v-label--is-disabled.theme--light {
  color: var(--v-label-base) !important;
  font-weight: bold;
}

.v-input--checkbox .v-label.theme--light,
.v-input--switch .v-label.theme--light {
  color: var(--v-text-base) !important;
  font-weight: 600;
}

.v-input__prepend-inner,
.v-input__append-inner,
.v-input__prepend-outer,
.v-chip {
  margin-top: 0px !important;
  margin-bottom: 0;
}
.v-subheader {
  height: 30px;
  margin-bottom: 8px;
}

.v-btn--floating.v-btn--small {
  height: 30px;
  width: 30px;
}

.v-tabs__item:not(.v-tabs__item--active) {
  opacity: 0.7;
}

.v-tabs__item {
  padding-top: 3px;
  background-color: var(--v-updatedGrey-base);
  margin-left: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
}

.auth-menu {
  z-index: 20;
}

.inactive-item {
  background-color: #ff7474;
}

a.inactif {
  color: rgba(0, 0, 0, 0.87);
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--text):not(
    .v-btn--outline
  ) {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.v-btn--icon {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.theme--dark.v-btn.v-btn--disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}

/* Affichage grisé des objets radiés */
.radie,
.radie * :not(.v-input--selection-controls__ripple) {
  background-color: var(--disabled-bg-color) !important;
}

/* Les entêtes */
.radie .v-subheader,
.radie .v-subheader * {
  border-radius: 5px;
  color: black !important;
}

/* Les boutons */
.radie .v-btn--disabled {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.radie .v-btn--disabled .v-btn__content,
.radie .v-btn--disabled .v-btn__content * {
  background-color: rgba(0, 0, 0, 0.226) !important;
}

.radie .v-btn:not(.v-btn--disabled),
.radie .v-btn:not(.v-btn--disabled) * {
  background-color: var(--v-primary-base) !important;
}

.v-input__icon {
  height: 20px;
}

.v-ripple__container {
  left: -3px;
}

.classStopCall .v-text-field input {
  background-color: red;
}

.classStopCallLabel .v-label {
  background-color: red;
}

.customIcon .v-input .material-icons {
  color: #e91e63;
  margin-top: 5px;
  margin-right: 0px;
}

.specific .v-tabs__item {
  padding-top: 0px !important;
  background-color: transparent !important;
  margin-left: 0px !important;
  padding-bottom: 0px !important;
  border-top-left-radius: 0px !important;
}

.specific .v-card__title {
  padding: 3px;
  font-size: 14px;
}

.classShowOff .v-text-field input {
  background-color: var(--v-updatedGrey-base);
}

.classShowOff .theme--light.v-label {
  z-index: 1;
}
.application--wrap .v-input--switch .v-input--selection-controls__ripple {
  left: -2px;
  top: 0;
}

.classShowOff .v-text-field input {
  background-color: var(--v-updatedGrey-base);
}
</style>
